export default __webpack_public_path__ + "static/media/4.ed8c8671.png";